import { useRef } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import "./App.css";

import { LanguageProvider } from "./contexts/LanguageContext";
import { useLenis } from "./hooks/useLenis";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Manifesto from "./components/Manifesto";
import Industries from "./components/Industries";
import Services from "./components/Services";
import Methodology from "./components/Methodology";
import CaseStudies from "./components/CaseStudies";
import HealthCheckQuiz from "./components/HealthCheckQuiz";
import WhyUs from "./components/WhyUs";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import AdminLeads from "./pages/AdminLeads";
import { Reveal } from "./components/motion/Reveal";

function Home() {
  useLenis();
  const quizRef = useRef(null);
  const openQuiz = (industry) => quizRef.current?.open(industry);

  return (
    <div className="App bg-cb-cream" data-testid="app-root">
      <Header onCTAClick={() => openQuiz()} />
      <main>
        <Hero onCTAClick={() => openQuiz()} />
        <Marquee />
        <Reveal><Industries onPickIndustry={(id) => openQuiz(id)} /></Reveal>
        <Manifesto />
        <Reveal><Services /></Reveal>
        <HealthCheckQuiz ref={quizRef} />
        <Reveal><Methodology /></Reveal>
        <CaseStudies />
        <Reveal><WhyUs /></Reveal>
        <Reveal><Testimonials /></Reveal>
        <Reveal><FAQ /></Reveal>
        <Reveal><Contact /></Reveal>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminLeads />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </LanguageProvider>
  );
}
